import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// INITIAL STATE
const initialState = {
  pending: false,
  fulfilled: false,
  rejected: false,
  success: false,
  redirectUrl: null,
  error: null,
};

// CREATE ACTION
export const smsVerificationCodeAction = createAsyncThunk(
  "smsVerificationCode/validate",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_LFCONNECT_FUNCTIONS_DOMAIN}/users/me/integrations/${payload.appId}/verify-phone-number`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${payload.token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      const errorResponse = error.response;
      if (
        errorResponse &&
        errorResponse.data &&
        errorResponse.data.LFconnect &&
        errorResponse.data.exception &&
        errorResponse.data.exception.innerErrors &&
        errorResponse.data.exception.innerErrors.length > 0
      )
        return rejectWithValue(errorResponse.data.exception.innerErrors[0].target);
      else
        return rejectWithValue(
          `${error.message} - Please contact System Administrator.`
        );
    }
  }
);

// CREATE SLICE
const smsVerificationCodeInBodySlice = createSlice({
  name: "smsVerificationCodeInBody",
  initialState,
  extraReducers: (builder) => {
    //update account
    builder.addCase(smsVerificationCodeAction.pending, (state, action) => {
      state.pending = true;
      state.fulfilled = false;
      state.rejected = false;
      state.redirectUrl = null;
      state.error = null;
    });
    builder.addCase(smsVerificationCodeAction.fulfilled, (state, action) => {
      state.pending = false;
      state.fulfilled = true;
      state.redirectUrl = action.payload.redirectUrl;
      state.rejected = false;
      state.error = null;
    });
    builder.addCase(smsVerificationCodeAction.rejected, (state, action) => {
      state.pending = false;
      state.fulfilled = false;
      state.redirectUrl = null;
      state.rejected = true;
      state.error = action.payload;
    });
  },
});

// CREATE REDUCER
const smsVerificationCodeInBodyReducer = smsVerificationCodeInBodySlice.reducer;
export default smsVerificationCodeInBodyReducer;
